import React from 'react';
export const MetricsTestimonialsSection = () => {
  const metrics = [{
    value: '+800',
    label: 'estudiantes usan el pack'
  }, {
    value: '9',
    label: 'Módulos y Bonos incluidos'
  }, {
    value: '180',
    label: 'páginas de contenido'
  }, {
    value: '4,9/5',
    label: 'calificación ⭐'
  }];
  return <section className="bg-megapack-section py-10 md:py-16 px-4 md:px-6" data-id="element-135">
      <div className="max-w-7xl mx-auto w-[92%] md:w-full" data-id="element-136">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8" data-id="element-137">
          {metrics.map((m, i) => <div key={i} className="text-center bg-megapack-card/30 md:bg-transparent rounded-xl p-4 md:p-0" data-id="element-138">
              <div className="text-3xl sm:text-5xl md:text-6xl font-bold mb-1 md:mb-2 text-megapack-cyan" data-id="element-139">
                {m.value}
              </div>
              <div className="text-[13px] sm:text-base text-white/80 font-medium leading-tight" data-id="element-140">
                {m.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};